export var Polygon;
(function (Polygon) {
    /**
     * The GeoJSON type.
     */
    let type;
    (function (type) {
        type["POLYGON"] = "Polygon";
    })(type = Polygon.type || (Polygon.type = {}));
})(Polygon || (Polygon = {}));
